import { Link, NavLink } from 'react-router';

import { cn } from '@repo/ui/lib/utils';

const LINKS = [
  { to: '/photovogue', label: 'Moderation', end: true },
  { to: '/photovogue/pic-of-the-day', label: 'Pic of the Day', end: false },
  { to: '/photovogue/admin/photographers', label: 'Photographers', end: false },
];

export const PhotoVogueNav = () => (
  <header className="flex flex-wrap items-center gap-2 border-b bg-white px-3 py-2 sm:gap-4 sm:px-4 sm:py-3 md:px-6">
    <div className="flex items-center gap-2">
      <span className="text-sm font-bold tracking-tight">PhotoVogue</span>
      <span className="rounded bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-cn-muted-foreground">
        Admin
      </span>
    </div>

    <nav className="order-last flex w-full items-center gap-1 overflow-x-auto sm:order-none sm:w-auto">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'whitespace-nowrap rounded-md px-2 py-1.5 text-xs font-medium transition-colors sm:px-3 sm:text-sm',
              isActive
                ? 'bg-zinc-900 text-white'
                : 'text-cn-muted-foreground hover:bg-zinc-100',
            )
          }
        >
          {link.label}
        </NavLink>
      ))}
    </nav>

    <Link
      to="/"
      className="ml-auto text-sm font-medium text-cn-muted-foreground underline-offset-4 hover:text-cn-foreground hover:underline"
    >
      ← Open Calls
    </Link>
  </header>
);

export default PhotoVogueNav;
